export const FETCH_APPLICATION = 'FETCH_APPLICATION';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_ERROR = 'FETCH_APPLICATION_ERROR';

export const FINAL_LEASE_SUCCESS_DATA = 'FINAL_LEASE_SUCCESS_DATA';
export const FINAL_LEASE_SUCCESS_DATA_SUCCESS = 'FINAL_LEASE_SUCCESS_DATA_SUCCESS';
export const FINAL_LEASE_SUCCESS_DATA_ERROR = 'FINAL_LEASE_SUCCESS_DATA_ERROR';

export const FETCH_LEASE_WORKFLOW_HISTORY = 'FETCH_LEASE_WORKFLOW_HISTORY';
export const FETCH_LEASE_WORKFLOW_HISTORY_SUCCESS = 'FETCH_LEASE_WORKFLOW_HISTORY_SUCCESS';

export const LEASE_CANCEL_APPLICATION = 'LEASE_CANCEL_APPLICATION';
export const LEASE_CANCEL_APPLICATION_SUCCESS = 'LEASE_CANCEL_APPLICATION_SUCCESS';
export const LEASE_CANCEL_APPLICATION_ERROR = 'LEASE_CANCEL_APPLICATION_ERROR';
